// root store
import root from '#/stores/root'

import { createStore } from 'vuex'

// apps store
import auth from '@/libvue/apps/auth/store'
import categories from '@/libvue/apps/catalog/categories/store'
import exports from '@/libvue/apps/catalog/exports/store'
import favorites from '@/libvue/apps/catalog/favorites/store'
import homepages from '@/libvue/apps/catalog/homepages/store'
import items from '@/libvue/apps/catalog/items/store'
import lineups from '@/libvue/apps/catalog/lineups/store'
import playlists from '@/libvue/apps/catalog/playlists/store'
import screeners from '@/libvue/apps/catalog/screeners/store'
import courses from '@/libvue/apps/courses/store'
import newsletter from '@/libvue/apps/newsletter/store'
import request from '@/libvue/apps/request/store'
import subscribers from '@/libvue/apps/subscribers/store'
import reports from '@/libvue/apps/team/reports/store'
import team from '@/libvue/apps/team/store'
import user from '@/libvue/apps/user/store'
import ratings from '@/libvue/components/rating/store'

const debug = process.env.NODE_ENV !== 'production'

export default createStore({
  modules: {
    root,
    // apps
    auth,
    team,
    reports,
    user,
    courses,
    items,
    screeners,
    categories,
    subscribers,
    favorites,
    playlists,
    homepages,
    lineups,
    ratings,
    newsletter,
    exports,
    request,
  },
  strict: debug,
})
